export const toDiscountPrice = (value) => {
    if (value === '' || value === null || value === undefined) return null;
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return null;
    return n;
};

export const isVariantDiscountOverridden = (variantDiscount, parentDiscount) =>
    toDiscountPrice(variantDiscount) !== toDiscountPrice(parentDiscount);

export const resolveVariantDiscountPrice = ({
    variantDiscount,
    discountOverridden,
    previousParentDiscount,
    nextParentDiscount,
}) => {
    const current = toDiscountPrice(variantDiscount);
    const previousParent = toDiscountPrice(previousParentDiscount);
    const nextParent = toDiscountPrice(nextParentDiscount);
    const overridden =
        discountOverridden === true ||
        (discountOverridden !== false && current !== previousParent);

    return overridden ? current : nextParent;
};
